import serviceUrls from 'src/constants/serviceUrls';
import { CASES_FILTERS } from 'src/constants/constants';
import axiosRequest from 'src/helpers/axiosRequest';

export function createQuickViewDetail(params = {}) {
  return axiosRequest('post', serviceUrls.CASE_CREATE_QVDATA_DETAIL, params);
}

export function fetchCases(filters = {}, config) {
  return axiosRequest('post', serviceUrls.CASES_GET_CASES, filters, config);
}

export function getAppTypesByCountry(countryId) {
  return axiosRequest('get', serviceUrls.CASES_GET_APPLICANT_TYPE_BY_COUNTRY + countryId);
}

export function fetchDetailsHeader(caseId = '', isAllData) {
  return axiosRequest('get', serviceUrls.CASES_GET_DETAILS_HEADER, { caseId, isAllData });
}

export function fetchCaseDetail(caseId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_CASE_DETAIL, {
    caseId,
  });
}

export function fetchBpfStatus(caseId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_CASE_BPF, {
    caseId,
  });
}

export function fetchCountryMapping(caseId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_COUNTRY_MAPPING, {
    caseId,
  });
}

export function fetchCountryFormDetail(caseId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_QVDATA_DETAIL, {
    caseId,
  });
}

export function fetchQuickViewDetailById(caseId = '', formDataId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_QVDATA_DETAIL_BY_ID, {
    caseId,
    formDataId,
  });
}

export function fetchCaseQuestionnaireList(caseId = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_QUESTIONNAIRE_LIST, { caseId });
}

export function fetchFieldData(field = CASES_FILTERS.ENGAGEMENTS) {
  return axiosRequest('get', serviceUrls[`GET_${field}`]);
}

export function searchCases(email) {
  return axiosRequest('get', serviceUrls.AUTOCOMPLETE_SERVICE, {
    email: email,
  });
}

export function fetchCaseClients() {}

export function fetchCaseEntities() {
  return axiosRequest('get', serviceUrls.CASES_GET_ENTITY);
}

export function fetchCasePathways() {
  return axiosRequest('get', serviceUrls.CASES_GET_PATHWAY);
}

export function fetchCaseDaysOld() {
  return axiosRequest('get', serviceUrls.CASES_GET_DAYSOLD);
}

export function fetchCasePhases() {
  return axiosRequest('get', serviceUrls.CASES_GET_PHASE);
}

export function fetchStatusId() {
  return axiosRequest('get', serviceUrls.CASES_GET_STATUS_ID);
}

export function getCaseFiltersAPI() {
  return axiosRequest('get', serviceUrls.CASES_GET_FILTERS);
}

export function getImmigrationPathway() {
  return axiosRequest('get', serviceUrls.CASES_GET_PATHWAYS);
}

export function fetchImmigrationCasePathway(payload) {
  return axiosRequest('get', serviceUrls.CASES_GET_CASE_PATHWAYS, payload);
}

export function saveCasePathway(payload) {
  return axiosRequest('post', serviceUrls.CASES_SAVE_PATHWAYS, payload);
}

export function fetchCaseMessagesCounts(params) {
  const filter = !!(params.dateFrom || params.dateTo || params.engagement || params.priority);

  return axiosRequest('post', serviceUrls.MESSAGING_INBOX_SERVICE, {
    pageSize: 100,
    pageNumber: 1,
    ...params,
    filter,
  });
}

export function saveCaseDetail(params = {}) {
  return axiosRequest('post', serviceUrls.CASES_SAVE_CASE_DETAIL, params);
}

export function saveCaseDetailWithCountryMappingId(params = {}) {
  return axiosRequest('post', serviceUrls.CASES_SAVE_COUNTRY_MAPPING, params);
}

export function saveQuickViewDetail(params = {}) {
  return axiosRequest('post', serviceUrls.CASES_SAVE_QVDATA_DETAIL, params);
}

export function updateCasePhaseService(params) {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_CASE_PHASE, params);
}

export function fetchCasePhasesService(params) {
  return axiosRequest('get', serviceUrls.CASES_CASE_PHASES, params);
}

export function getClientLineManagersAPI(params) {
  return axiosRequest('get', serviceUrls.CASES_GET_CLIENT_LM, params);
}

export function getLineManagersAPI(params) {
  return axiosRequest('get', serviceUrls.CASES_GET_LM, params);
}

export function saveAddNewLineManagersAPI(params) {
  return axiosRequest('post', serviceUrls.CASES_SAVE_CLIENT_LM, params);
}

export function fetchApplicantCaseDetails(caseId) {
  return axiosRequest('get', serviceUrls.CASES_GET_APPLICANT_CASE_DETAILS, { caseId });
}

export function fetchTasks(caseId) {
  return axiosRequest('get', serviceUrls.CASES_GET_ACTIONS, { caseId });
}

export function fetchMessagesCount(caseId) {
  return axiosRequest('get', serviceUrls.CASES_GET_MESSAGES_COUNT, { caseId });
}

export function fetchDocumentsCount(caseId, isExpiring) {
  return axiosRequest('get', serviceUrls.CASES_GET_DOCUMENTS_COUNT, { caseId, isExpiring });
}

export function fetchContacts(params) {
  return axiosRequest('post', serviceUrls.CASES_GET_CONTACTS, params);
}

export function fetchCaseStatusInfo(id = '') {
  return axiosRequest('get', serviceUrls.CASES_GET_STATUS_INFO, { id });
}

//New Case data Service URLS

export function getDashboardCaseDetails(caseId, isDashboard = 'false') {
  return axiosRequest('get', serviceUrls.GET_DASHBOARD_CASE_DETAILS, { caseId, isDashboard });
}

export function getCaseCountHeader(isAllData) {
  return axiosRequest('get', serviceUrls.GET_DASHBOARD_CASE_COUNT_DETAILS, { isAllData });
}
